<template>
    <v-ons-page>
        <TopBar back="true"></TopBar>
        <ons-list style="height: 100%">
            <ons-list-item class="listItem" style="padding: 0 10%; height: 50%" tappable @click="push('menu')">
                <div class=" alingCenter" >
                    <img :src="option1" width="90%"/>
                </div>

            </ons-list-item>

            <ons-list-item class="listItem" style="height: 50%; display: initial" tappable @click="push('creditPage')">
                <div class="alingCenter" style="margin-top: 25px">
                    <img :src="option2" width="25%"/>
                </div>
            </ons-list-item>
        </ons-list>
    </v-ons-page>
</template>

<script>
    import TopBar from '../components/TopBar'
    import MenuImagePage from './MenuImagePage'
    import BottomBar from '../components/BottomBar'
    import TextPage from './TextPage'
    import constatns from '../constants'
    import LoadingPage from './LoadingPage'
    import axios from 'axios'

    export default {
        name: 'selectOption',
        components: {
            TopBar,
            BottomBar
        },
        data: function () {
            return {
                menuItems: this.$t("message.menuItems"),
                option1: require('../assets/img/art/thumb_1.png'),
                option2: require('../assets/img/art/thumb_2.png'),
            }
        },
        methods: {
            push(type) {
                if (type == "menu"){
                    this.$emit('push', {
                        extends: MenuImagePage,
                    });
                }else if (type == "creditPage"){
                    this.$emit('push', {
                        extends: TextPage,
                        onsNavigatorProps: {
                            item: this.getItemCredits()
                        }
                    });
                }
            },

            getItemCredits() {

                this.menuItems.forEach((elementMenuItem,indexItem) => {


                    var idioma="";
                    let lang=this.$i18n.locale;
                    if (lang == "Castellano") {
                        idioma = "ESP";
                    } else if (lang == "Català") {
                        idioma = "CAT";
                    } else if (lang == "Français") {
                        idioma = "FRA";
                    } else if (lang == "English") {
                        idioma = "ENG";
                    }

                    elementMenuItem.path_audio =  "/audios/"+idioma+"/"+ elementMenuItem.audio;

                    if(elementMenuItem.isCredits) {
                        elementMenuItem.imgCredit = elementMenuItem.img;
                    }



                });
                return this.menuItems[this.menuItems.length-1];
            },

        },
    }
</script>
<style lang="css" src="../assets/css/styles.css"/>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .noBorder:last-child {
        margin: 0;
        padding: 0% 20%;
    }

    .alingCenter {
        width: 100%;
        text-align: center;
    }

    .listItem {
        padding: 0% 10%;

    }

    .mt10 {
        margin-top: 10%;
    }

    .mt3 {
        margin-top: 3%;
    }

    .itemList {
        margin: 5% 0%;
    }

    /*@import '../assets/css/styles.css';*/
</style>



// WEBPACK FOOTER //
// src/pages/SelectOptionPage.vue